function LoadingAnime({ label = "로딩 중..." }) {
  return (
    <div className="flex min-h-[50vh] w-full items-center justify-center">
      <div className="flex items-center gap-3 text-sm text-ink-200">
        <span className="h-3 w-3 animate-ping rounded-full bg-brand-400" />
        <span className="h-3 w-3 animate-pulse rounded-full bg-accent-400" />
        <span>{label}</span>
      </div>
    </div>
  );
}

export default LoadingAnime;
